import AlertBannerSpacer from "@pathwright/ui/src/components/alert/AlertBannerSpacer"
import {
  FULLSCREEN_LAYER_BASE,
  FULLSCREEN_LAYER_OVERLAY
} from "@pathwright/ui/src/components/fullscreen/Fullscreen"
import styled from "styled-components"

// Layering the Inbox layout higher than the fullscreen overlay
// which ensures all modals are covered by the Inbox layout.
// We currently don't use modals in the Inbox (apart from the AssignFlow's
// Success modal which is layered above fullscreen overlays) so this is fine
// for now at least. Will need a more robust solution if we ever want to
// use modals in the Inbox. This ensures opening Inbox from a modal will
// cover that modal.
const FULLSCREEN_LAYER_INBOX_OFFSET = 10
const zIndex = FULLSCREEN_LAYER_BASE + FULLSCREEN_LAYER_OVERLAY + FULLSCREEN_LAYER_INBOX_OFFSET

const InboxLayoutContainer = styled(AlertBannerSpacer)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  height: 100%;
  color: #000;
  position: relative;
  z-index: ${zIndex};
  background-color: black;
`

export default InboxLayoutContainer
